import {
  Edge,
  getBezierPath,
  getSmoothStepPath,
  Position,
  useInternalNode,
} from "@xyflow/react";
import {getEdgeParams, getNodeElement} from "@/utils/index";
import {FlowNodeTypes} from "@/types/node";

export const createFloatingEdge = ({
  sourceNodeId,
  targetNodeId,
}: {
  sourceNodeId: string;
  targetNodeId: string;
}): Edge => {
  return {
    id: `${sourceNodeId}->${targetNodeId}`,
    source: sourceNodeId,
    target: targetNodeId,
    type: "floating",
    style: {
      strokeDasharray: "10,10",
      stroke: "#e4e4e7",
      strokeWidth: 2,
    },
  };
};

function FloatingEdge({id, source, target, markerEnd, style}) {
  const sourceNode = useInternalNode(source);
  const targetNode = useInternalNode(target);

  if (!sourceNode || !targetNode) {
    return null;
  }

  const {sx, sy, tx, ty, sourcePos, targetPos} = getEdgeParams(
    sourceNode,
    targetNode,
  );

  const isTargetBranch = targetNode.data.type === FlowNodeTypes.BRANCH;
  const nodeElement = getNodeElement(targetNode.id);
  const nodeElementWidth = nodeElement?.offsetWidth || 0;
  const nodeElementContentWidth =
    (nodeElement?.querySelector(".branch-node") as HTMLElement)?.offsetWidth ||
    0;
  const branchXHandlesOffset = isTargetBranch
    ? (nodeElementWidth - nodeElementContentWidth) / 2
    : 0;

  const [edgePath] = getSmoothStepPath({
    sourceX: sx,
    sourceY: sy,
    targetX: tx + branchXHandlesOffset * (targetPos === Position.Left ? 1 : -1),
    targetY: ty,
    sourcePosition: sourcePos,
    targetPosition: targetPos,
    borderRadius: 24,
  });

  return (
    <path
      id={id}
      className="react-flow__edge-path"
      d={edgePath}
      strokeWidth={5}
      markerEnd={markerEnd}
      style={style}
    />
  );
}

export default FloatingEdge;
